import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';
import StoreChip from '../../../Components/StoreChip/StoreChip';

interface OrderRowProps {
  order: any;
  index: number;
}

const OrderRow: React.FC<OrderRowProps> = ({ order, index }) => {
  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>
        <StoreChip shopDomain={order.shop_domain} />
      </TableCell>
      <TableCell>{new Date(order.createdAt).toLocaleDateString()}</TableCell>
      <TableCell>{order.totalPrice}</TableCell>
      <TableCell>
        {order.lineItems.map((item: any) => (
          <div key={item.title}>
            {item.title}
          </div>
        ))}
      </TableCell>
      <TableCell>
        {order.lineItems.map((item: any) => (
          <div key={item.title}>
            {item.quantity}
          </div>
        ))}
      </TableCell>
      <TableCell>
        <Chip label={order.fulfillmentStatus || 'Pending'}/>
      </TableCell>
    </TableRow>
  );
};

export default OrderRow;
